export default {
  loadHeadScript: function (scriptUrl, loadCallback, failCallback) {
    // TODO: Lock entire operation
    const headScripts = document.head.getElementsByTagName('script')
    for (const headScript of headScripts) {
      if (headScript.src === scriptUrl) {
        loadCallback()
        return
      }
    }

    const script = document.createElement('script')
    script.setAttribute('src', scriptUrl)
    script.onload = loadCallback
    script.onerror = failCallback
    document.head.appendChild(script)
  }
}
